import React, {useState} from'react';
import AnimationAsClass from './PathAnimation';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import PieChart from "../charts/PieChart";
import Xarrow, {useXarrow} from 'react-xarrows'
import logo from '../../assets/images/logo.png' 
import wallbox from '../../assets/icons/wallbox.png'
import pv from '../../assets/icons/pv.png'
import heatbiogas from '../../assets/icons/heatbiogas.png'
import heatgas from '../../assets/icons/heatgas.png'
import grid from '../../assets/icons/grid.png'
import heatoil from '../../assets/icons/heatoil.png'
import heathp from '../../assets/icons/heathp.png'
import chp from '../../assets/icons/chp.png'
import heatwood from '../../assets/icons/heatwood.png' // = Hackschnitzel?
import batt from '../../assets/icons/batt.png'
import heatelec from '../../assets/icons/heatelec.png'
import heatother from '../../assets/icons/heatother.png' // = heizung?
import pellet from '../../assets/icons/pellet.png'
import heatstore from '../../assets/icons/heatstore.png'
import pwrconsumpt from '../../assets/icons/pwrconsumpt.png'
import {splitData} from '../sum/SumUtils'
import Sum from '../sum/Sum';
import "./SensorList.css";

import {calculateSpread} from '../utils/HelperDiv';
import VertStackedChart from '../charts/VertStackedChart';

import '../../assets/scss/SensorList.scss';


const RectangleList = (props) =>{

    let images = 
    [ grid, logo, wallbox, heathp,
    pv, pellet, heatbiogas, heatgas, 
    heatwood, heatelec, heatother, heatoil, 
    chp, batt, pwrconsumpt, heatstore ];

    //deleted updateXArrow used for updating revert back if any sideEffects with arrow updating occur 19.03.23
    
    
    let distance = (100/ (props.rectangles.length + 1));

    let sortedRectangles = props.rectangles.sort((a,b) => a.visuPosition - b.visuPosition);
    
    const renderRectangleList =  sortedRectangles.map( (rectangle, index)  => {

        let imageSource;
        let powerType = rectangle.powerType.toLowerCase().trim();
        
        let myLeft, popUpDirection;
        let rectId;
        let dataHolder = [];
        let chartDataIn;
        let dataInArray = [];
        let chartDataOut;
        let dataOutArray = [];
        let energyIn = 0;
        let energyOut = 0;
        let sideOfIcons = 12;
        let gapBetweenIcons = distance - sideOfIcons;
        let topOfInfoBox = ((sideOfIcons / 2) + (gapBetweenIcons * 0.2)/(2));
        let lengthOfInfoBox = (gapBetweenIcons * 0.8);
        let infoSide;
        let myFontSize = 2;

        // more icons means make them smaller so there is no overlapping 
        // 5 icons = 8vh
        // 6 icons = 7vh 
        // 7 icons = 6vh
        // 8 icons = 5vh ?
        
        if (props.rectangles.length == 5){
            
            sideOfIcons = 9;
            gapBetweenIcons = distance - sideOfIcons;
            topOfInfoBox = ((sideOfIcons / 2) + (gapBetweenIcons * 0.2)/(2));
            lengthOfInfoBox = (gapBetweenIcons * 0.8);
            
        } else if ( props.rectangles.length == 6 ){
            sideOfIcons = 8;
            gapBetweenIcons = distance - sideOfIcons;
            topOfInfoBox = ((sideOfIcons / 2) + (gapBetweenIcons * 0.2)/(2));
            lengthOfInfoBox = (gapBetweenIcons * 0.8);
            myFontSize = 1.5;
        } else if ( props.rectangles.length == 7 ){
            sideOfIcons = 7;
            gapBetweenIcons = distance - sideOfIcons;
            topOfInfoBox = ((sideOfIcons / 2) + (gapBetweenIcons * 0.2)/(2));
            lengthOfInfoBox = (gapBetweenIcons * 0.8);
            myFontSize = 1.4;
        } else if ( props.rectangles.length == 8 ){
            sideOfIcons = 6;
            gapBetweenIcons = distance - sideOfIcons;
            topOfInfoBox = ((sideOfIcons / 2) + (gapBetweenIcons * 0.2)/(2));
            lengthOfInfoBox = (gapBetweenIcons * 0.8);
            myFontSize = 1.4;
        }

        if(lengthOfInfoBox >= 8){
            lengthOfInfoBox = 8;
            gapBetweenIcons = lengthOfInfoBox * 0.2
            topOfInfoBox = ((sideOfIcons / 2) + (gapBetweenIcons * 0.2)/(2));
        }

        let searchImage = images.findIndex(searchImage => {
            let imageName = searchImage.split('/').pop().split('.')[0];
            return imageName === powerType;
        });

        if (searchImage === -1){
            imageSource = logo;
        } else {
            imageSource = images[searchImage];
        }

        rectangle.top = (index + 1) * distance;
        
        //Preparing Data for Graphs
        dataHolder = splitData(rectangle, props.availableEnergie, props.timeSpan);
        
        for (let [key, value] of Object.entries(dataHolder)) {   
            if (value.energyDirection == 1) {
                energyIn += value.energyKWh;
                
                dataInArray.push(value);
            } else {
                energyOut += value.energyKWh;
                dataOutArray.push(value);
            }
        }

        if (dataInArray.length > 0) {
            chartDataIn = {

                labels: dataInArray.map((data) => 
                props.powerTypes[data.powerType].powerNameDE ? 
                props.powerTypes[data.powerType].powerNameDE : "kein Name"),

                datasets: [
                    {
                        label: 'kWh:',
                        data: dataInArray.map((data) => data.energyKWh),
                        backgroundColor: 
                            dataInArray.map((data) => data.color)
                        ,
                        borderColor: 'black',
                        borderWidth: 2
                    }
                ]
            };
        }

        if (dataOutArray.length > 0) {
            chartDataOut = {

                labels: dataOutArray.map((data) => 
                props.powerTypes[data.powerType].powerNameDE ? 
                props.powerTypes[data.powerType].powerNameDE : "kein Name"),

                datasets: [
                    {
                        label: 'kWh:',
                        data: dataOutArray.map((data) => data.energyKWh),
                        backgroundColor: 
                            dataOutArray.map((data) => data.color)
                        ,
                        borderColor: 'black',
                        borderWidth: 2
                    }
                ]
            };
        }   

        if (props.direction === "Left"){
            rectId = index + "L";
            myLeft = '50px'      
            popUpDirection = "right center";
            infoSide="L";

           
            //console.log(rectangle.pottieDescription, chartDataIn, chartDataOut);


            

        } else {
            rectId = index + "R";
            myLeft = 'calc(100% - 150px)';
            popUpDirection = "left center";
            infoSide="R";
        }

        return(

            <div>
                
                <Popup 
                    trigger={     
                        <img             
                            className={`rectangle-image${infoSide}`}
                            id={'rect_'+rectId}
                            style = {{
                                position: "absolute",
                                top: `calc(${rectangle.top}vh - 6vh)`,
                                left: myLeft,
                                width: `${sideOfIcons}vh`,
                                height: `${sideOfIcons}vh`,
                                marginTop: `-${sideOfIcons/2}vh`,
                            }}
                            src={imageSource}/>
                    }

                    position= {popUpDirection} 
                    className="MyCoolPopup"
                    on="hover" 
                    offsetY={ 
                        (chartDataIn && chartDataOut && rectangle.visuPosition == props.rectangles.length && props.rectangles.length >= 6) ? 
                         -100 : (
                            (chartDataIn && chartDataOut && index == 0) ? 70: 
                            ( ((!chartDataIn ^ !chartDataOut) && index == 0) ? 30: 0)
                         ) }
           
                    contentStyle={{
                        display: "inline-block",
                    }}

                    closeOnDocumentClick>
                    {close => (
                      
                       
                       <div
                       style={{
                        
                       }}
                       >
                       {chartDataIn && chartDataOut ? (
                         <>
                           <div
                           style={{
                            flexShrink:"2",
                           }}
                           >
                             <PieChart chartData={chartDataIn} header="Energie In" />
                           </div>
                           <div
                           style={{
                            flexShrink:"2",
                           }}
                           >
                             <PieChart chartData={chartDataOut} header="Energie Out" />
                           </div>
                         </>
                       ) : chartDataIn ? (
                         <div>
                           <PieChart chartData={chartDataIn} header="Energie In" />
                         </div>
                       ) : chartDataOut ? (
                         <div>
                           <PieChart chartData={chartDataOut} header="Energie Out" />
                         </div>
                       ) : (
                         'keine Daten verfügbar'
                       )}
                     </div>
                     
                    )}
                </Popup>
                
                <div
                    className={`info-box${infoSide}`}
                    style = {{
                        position: 'absolute',
                        display: "flex",
                        justifyContent: "flex",
                        flexDirection: 'column',
                        width: `${sideOfIcons}vh`,                        
                        alignItems: 'center',
                        height: `${lengthOfInfoBox}vh`,
                        gap: "0px",
                        top: `calc((${rectangle.top}vh + ${topOfInfoBox}vh - 6.75vh))`,
                        left: myLeft
                    }}>

                    <div
                    style = {{
                        height: `${(lengthOfInfoBox / 3)}vh`,
                    }}>
                        <p
                        style={{
                            minWidth: "fit-content",
                            textAlign: "right",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontSize: `${myFontSize}vh`
                        }}>{rectangle.pottieDescription}</p>
                    </div>
                    <Sum
                    side={infoSide}
                    rec={rectangle.epotPottieName}
                    testing={rectangle}
                    className = "inOutBadge"
                    energyIn={energyIn}
                    energyOut={energyOut}
                    length={lengthOfInfoBox}
                    energy = {dataHolder}
                    rectangle = {rectangle}
                    myFontSize = {myFontSize}
                    />
                </div>
                    
                    
                    
                  
                    {/* {chartDataOut ? 
                            <div>
                                <VertStackedChart chartData={chartDataOut} header="Strom In"/>
                            </div> :''}      */}
                    
                  
                    { (rectangle.powerType != "NOPOWER") ? 
                    (<><div 
                    id={'arrow_'+rectId}>
                        <Xarrow 
                            key={rectId + 1}
                            start={'rect_'+rectId}
                            end={`helper-${index}-${props.direction}`}
                            color="Black"
                            showHead={false}
                            showTail={false}
                            headSize={0}
                            tailSize={0}
                            strokeWidth={2}
                            /> 
                    </div>
                
                <AnimationAsClass 
                    rectId={rectId}
                    key={rectId}
                    radius={15}
                    speed={8}
                    data={dataHolder}
                    in = {dataInArray}
                    out = {dataOutArray}
                    total = {props.total}
                /></>) : <div></div>}
            </div>
        );
    });

    return (
        <div
        className='flex_'
        style={{
            display: "flex",
            flexDirection: "column",

        }}>
            {renderRectangleList}
        </div>
    );
}

export default RectangleList;

